import React, { useState } from "react";
import { UploadSimple } from "@phosphor-icons/react";
import { ExtendedSidebar } from "./ExtendedSidebar";
import { SearchAction } from "./SearchAction";
import { PlusMenu } from "./PlusMenu";
import { UploadModal } from "./DataSidebar/UploadModal";

export const DataActions: React.FC = () => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  return (
    <>
      <PlusMenu allowedTypes={["object", "vectorMemory"]} />
      <ExtendedSidebar.ActionButton icon={UploadSimple} onClick={() => setUploadModalOpen(true)} />
      <SearchAction />
      <UploadModal open={uploadModalOpen} onClose={() => setUploadModalOpen(false)} />
    </>
  );
};
